import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-waiting-for-response-modal',
    templateUrl: './waiting-for-response-modal.component.html',
    styleUrls: ['./waiting-for-response-modal.component.scss'],
    standalone: false
})
export class WaitingForResponseModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
